import { Injectable } from '@angular/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { ValidationService } from '@app/shared/services/validation.service'
import { EmailAddressNameFormService } from '@app/modules/email-address-name/email-address-name-form.service'
import { EmailAddress } from '@app/modules/email-address/email-address.model'

@Injectable()

export class EmailAddressFormService {

  /**
   * Insert vaildators
   */
  public insertValidators: Array<any> = [
    {
      emailAddressNameUuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    },
    {
      email: [
        Validators.required,
        Validators.maxLength(191),
        ValidationService.isValidEmail
      ]
    }
  ]

  /**
   * Update validators
   */
  public updateValidators: Array<any> = [
    {
      uuid: [
        Validators.required,
        ValidationService.isUuid
      ]
    }
  ]

  /**
   * Constructor
   */
  public constructor (
    private formBuilder: FormBuilder,
    public validationService: ValidationService,
    private emailAddressNameFormService: EmailAddressNameFormService
  ) {}

  /**
   * Get form
   */
  public getForm (emailAddress: EmailAddress, type: string): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      uuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      emailAddressNameUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      email: [
        null,
        [
          Validators.maxLength(191),
          ValidationService.isValidEmail
        ]
      ],
      // Info.
      createdAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      updatedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      deletedAt: [
        null,
        [
          ValidationService.noWhiteSpace
        ]
      ],
      createdByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ],
      updatedByUuid: [
        null,
        [
          ValidationService.isUuid
        ]
      ]
    })

    if (type === 'new') {
      this.validationService.addInsertValidators(form, this.insertValidators)
    }

    if (type === 'edit') {
      this.validationService.addUpdateValidators(form, this.insertValidators, this.updateValidators)
    }

    if (emailAddress.emailAddressName) {
      form.addControl('emailAddressName', this.emailAddressNameFormService.getForm(emailAddress.emailAddressName, ''))
    }

    if (emailAddress) {
      form.patchValue(emailAddress, { emitEvent: false })
    }

    return form
  }

}
